const CollectionsMenuIcon = ({
  className,
}: {
  readonly className?: string | undefined;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <g transform="translate(128 128) scale(1 1.22) translate(-128 -128)">
      <path d="M236.6,165.2c3.7-12.1,11.9-26.4,8.7-44c-3.3-12.2-6.7-24.4-10.1-36.6c-2.3-14.9,21.8-29.1,3.7-43c-16.7-12.9-35.3,10.2-55,6.4c-8.5-1.6-13-8.2-20.6-10.1c-13.1-3.3-22.1,8.2-33,10.1c-12,2.1-17.2-8-25.6-10.1C91.2,34.5,81.6,46,71.3,48C58.5,50.3,41.1,37.8,25,37.9c-4.1,2.3-8.3,3.2-11,6.9C2.8,60,23.3,69.8,20.9,84.6c-2.5,15.8-14.1,29.7-10.1,50.8c3.4,12.1,6.7,24.1,10.1,36.2c2.4,14.9-18.1,24.6-6.9,39.8c13.6,18.5,38-6.2,57.2-3.2c10.5,1.6,15.9,12.8,28.8,10.1c9.6-2,17.5-12,29.8-10.1c10.5,1.6,15.8,12.7,28.8,10.1c9.2-3.3,18.3-6.7,27.5-10.1c17.6-1.7,42.5,21.2,55.9,3.2C253.7,195.7,231.2,182.8,236.6,165.2zM216,188.1c-4.4,5.5-25.9,2.7-35.3,2.7c-34.3,0-68.7,0-103,0c-11.1,0-34.3,3.1-38.5-4.1c-3.2-5.5-0.9-20.4-0.9-27.9c0-29,0-58,0-87c0.9-3.5,3.7-4.6,6.4-6.4c41.7,0,83.3,0,125,0c9.8,0,40.1-2.3,45.3,1.8c5.1,4.1,2.7,55.7,2.7,67.8C217.8,145.8,220.4,182.5,216,188.1z" />
    </g>
    <path d="M159.6,118.9c19.8-5.1,17.1-36.9-6.9-36.2c-7.7,3.3-13.3,5.2-15.6,13.7C133.6,110.2,146.1,122.4,159.6,118.9z" />
    <path d="M161.5,136.8c-10.4,1.9-18.1,17.1-31.6,9.6c-13.7-7.7-22.5-35.7-39.4-36.6c-13.5,8.5-31.7,39.5-34.3,58.2c5.6,8.1,22.3,5.5,35.7,5.5c23.5,0,47,0,70.5,0c12.2,0,27.2,1,36.6-1.8c0.5-0.6,0.9-1.2,1.4-1.8C199,161.8,172.6,134.7,161.5,136.8z" />
  </svg>
);

export default CollectionsMenuIcon;
